import React from 'react';
import moment from 'moment';

import FormGroup from '~/commons/components/FormGroup.jsx';
import { env } from '~/commons/config/';
import { startCase } from 'lodash';
import FormResource from './FormResource.jsx';

const defaults = {
  status: 'active',
  creator: {
    name: '',
  },
  stallion: {
    name: '',
  },
  player: {
    name: '',
  },
  mare: {
    name: '',
  },
  price: '',
  dge: 0,
  gxe: 0,
  expiredAt: '',
};

const FormBreed = ({ breed }) => (
  <FormResource
    {...{
      defaults,
      formStatus: { disabled: true },
      stored: breed
        ? {
          ...breed,
          expiredAt: {
            date: moment(breed.endAt).format('YYYY-MM-DD'),
            time: moment(breed.endAt).format('HH:mm'),
          },
          price: breed.price/1000000000,
          dge: breed.dge/1000000000,
          gxe: breed.gxe/1000000000,
        }
        : undefined,
      api: '/api/site/breeds',
      onSubmit: (v) => ({
        ...v,
        expiredAt: moment(`${v.expiredAt.date} ${v.expiredAt.time}`, 'YYYY-MM-DD HH:mm').toDate(),
      }),
    }}
  >
    <FormGroup name="status" as="select">
      {(env?.status?.breeding || []).map((s) => (
        <option key={s} value={s}>
          {startCase(s)}
        </option>
      ))}
    </FormGroup>
    <FormGroup name="creator.name" label="Creator" />
    <FormGroup name="stallion.name" />
    <FormGroup name="player.name" label="Player" />
    <FormGroup name="mare.name" />
    <FormGroup name="price" />
    <FormGroup name="dge" />
    <FormGroup name="gxe" />
  </FormResource>
);

export default FormBreed;
